import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-jodo-popup-info-dialog',
  templateUrl: './jodo-popup-info-dialog.component.html',
  styleUrls: ['./jodo-popup-info-dialog.component.css']
})
export class JodoPopupInfoDialogComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
  }

}
